export default "__VITE_PUBLIC_ASSET__aee1bfb2__"